var render = function render(_c,_vm){return (_vm.props.telegram)?_c('span',[_c('a',{attrs:{"href":_vm.props.domain + _vm.$options.methods.clearLogin(_vm.props.telegram)}},[_vm._v(" "+_vm._s(_vm.$options.methods.formatEmptyString(_vm.props.telegram))+" ")])]):_c('span',[_vm._v(" "+_vm._s(_vm.$options.methods.formatEmptyString(null))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }